import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadShipTos from "@insite/client-framework/Store/Pages/Addresses/Handlers/LoadShipTos";
import updateSearchFields from "@insite/client-framework/Store/Pages/Addresses/Handlers/UpdateSearchFields";

type HandlerType = Handler;

export const AddCacheBuster: HandlerType = props => {
    props.dispatch(
        updateSearchFields({
            additionalQueryStringParameters: {
                _: `${Date.now()}`,
            },
        }),
    );
};

export const ResetShipTosDataViews: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/ResetDataViews",
    });
};

export const ReloadShipTos: HandlerType = props => {
    props.dispatch(loadShipTos());
};

export const chain = [AddCacheBuster, ResetShipTosDataViews, ReloadShipTos];

const refreshShipTos = createHandlerChainRunner(chain, "RefreshShipTos");
export default refreshShipTos;